import React from 'react';
import { SupportTicketResolution } from '../types';

const TAG_COPY: Record<string, string> = {
  dashboard: 'Dashboard',
  device: 'Device',
  login: 'Login',
  billing: 'Billing',
  sensor_data: 'Sensor data',
  report: 'Report',
  mqtt: 'MQTT',
  account: 'Account',
  other: 'Other',
};

export default function SupportResolutionPanel({
  resolution,
  variant = 'tenant',
}: {
  resolution: SupportTicketResolution;
  variant?: 'tenant' | 'superadmin';
}) {
  const tags = Array.isArray(resolution.tags) ? resolution.tags : [];

  return (
    <section className={`sd-resolution-panel is-${variant}`} aria-label="Ticket resolution">
      <header>
        <div>
          <span>Resolution</span>
          <h3>{variant === 'superadmin' ? 'Structured Resolution' : 'Resolution from Seedronics Support'}</h3>
        </div>
        {variant === 'superadmin' && resolution.kb_candidate && <strong>KB candidate</strong>}
      </header>

      <div className="sd-resolution-highlight">
        <span>Customer update</span>
        <p>{resolution.customer_resolution}</p>
      </div>

      <div className="sd-resolution-grid">
        <ResolutionFact label="Issue" value={resolution.customer_issue} />
        <ResolutionFact label="Root cause" value={resolution.root_cause} />
        <ResolutionFact label="Fix applied" value={resolution.fix_applied} />
        <ResolutionFact label="Prevention" value={resolution.prevention_note} />
      </div>

      {variant === 'superadmin' && resolution.internal_notes && (
        <div className="sd-resolution-internal">
          <span>Internal notes</span>
          <p>{resolution.internal_notes}</p>
        </div>
      )}

      {(tags.length > 0 || resolution.created_at || resolution.resolved_by_email) && (
        <footer>
          {tags.length > 0 && (
            <div className="sd-resolution-tags">
              {tags.map((tag) => <span key={tag}>{TAG_COPY[tag] || tag}</span>)}
            </div>
          )}
          {variant === 'superadmin' && (
            <small>
              {resolution.resolved_by_name || resolution.resolved_by_email || 'Support'}{resolution.created_at ? ` resolved this on ${formatDate(resolution.created_at)}` : ''}
            </small>
          )}
        </footer>
      )}
    </section>
  );
}

function ResolutionFact({ label, value }: { label: string; value?: string | null }) {
  if (!value) return null;
  return (
    <div>
      <span>{label}</span>
      <p>{value}</p>
    </div>
  );
}

function formatDate(value: string) {
  return new Date(value).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
